//var scaleDropdownTempl = require('sma.common/components/partials/forms/scaledropdown.mustache');
var scaleTitleTempl = require('sma.common/components/partials/forms/scaletitle.mustache');


class SimpleBase extends Backbone.View {
	get events () {
		return {
			'click .custom-control': 'selectButton'
		}
	}

	get checkedClass () {
		return `${this.class}-selected`;
	}

	get wrappedClass () {
		return `${this.class}-wrap`;
	}

	initialize (options) {
		
		this.setElement(options.$el[0]);

		this.$lists = this.$el.find('.custom-control');
		this.$labels = this.$el.find('.custom-control-description');
		this.$inputs = this.$el.find('input');

		this.$el.addClass(this.wrappedClass);
	}

}

class YesNoRadio extends SimpleBase{
	get icons () {
		if (this.icon === 'thumb') {
			return {
				yes: 'emoticons_like',
				no: 'emoticons_like-no'
			}
		} else if (this.icon === 'symbol') {
			return {
				yes: 'ui-1_check-circle-08',
				no: 'ui-1_circle-remove'
			}
		} else if (this.icon === 'face') {
			return {
				yes: 'emoticons-e_smile-e',
				no: 'emoticons-e_sad-e'
			}
		}
	}

	get class () {
		return 'sma-yes-no-radio';
	}

	initialize (options) {
		super.initialize(options);

		this.icon = this.$inputs.first().data('icon');

		this.setIcons();
	}

	setIcons () {
		var that = this;

		this.$labels.each(function (){
			var $label = $(this);
			var $input = $label.closest('.custom-control').find('input');

			var id = $input.attr('id');

			var icon = parseInt(id.slice(-1)) ? 'no' : 'yes';

			$label.prepend($('<i></i>', {class: `nc-icon-mini ${that.icons[icon]}`}));

		});

	}

}

class RatingRadio extends SimpleBase {

	get class () {
		return 'sma-rating-radio';
	}

	get icons () {
		if (this.icon === 'star') {
			return {
				yes: 'nc-icon-glyph ui-2_favourite-31',
				no: 'nc-icon-outline ui-2_favourite-31'
			}
		} else if (this.icon === 'circle') {
			return {
				yes: 'nc-icon-mini weather_moon-full',
				no: 'nc-icon-mini food_plate'
			}
		} else if (this.icon === 'heart') {
			return {
				yes: 'nc-icon-mini ui-3_heart',
				no: 'nc-icon-mini ui-e-2_heart'
			}
		}
	}

	initialize (options) {
		super.initialize(options);

		this.icon = this.$inputs.first().data('icon');

		this.setIcons();

	}

	setIcons () {
		var that = this;
		var itemSelected = parseInt(this.$inputs.filter(':checked').val())

		this.$labels.each(function (i) {
			var $label = $(this);

			if (i <= itemSelected) {
				var icon = 'yes';
			} else {
				var icon = 'no'
			}

			$label.find('i').remove()
			$label.prepend($('<i></i>', {class: `${that.icons[icon]}`}));
		});
	}

	selectButton (e) {
		var $label = $(e.currentTarget);
		var $li = $label.closest('li');
		var $input = $label.find('input');

		this.$lists.removeClass(this.checkedClass);
		this.setIcons();

		if ($input.is(':checked')) {
			$li.addClass(this.checkedClass);
		}

	}

}

class ScaleSelect extends SimpleBase {
	get class () {
		return 'sma-scale-radio';
	}

	initialize (options) {
		super.initialize(options);

		this.$el.before('<h3>'+gettext('Select a rating')+'</h3>');
	}
}

$(function () {
	//create yes no widgets
	$('.sma-yes-no-radio').closest('.sma-simple-review-question-container').each(function () {
		new YesNoRadio({
			$el: $(this),
		});
	});

	//create rating widgets
	$('.sma-rating-radio').closest('.sma-simple-review-question-container').each(function () {
		new RatingRadio({
			$el: $(this),
		});
	});

	//create scale widgets
	$('.sma-scale-radio').closest('.sma-simple-review-question-container').each(function () {
		new ScaleSelect({
			$el: $(this),
		});
	});
});

module.exports = {
	YesNoRadio: YesNoRadio,
	RatingRadio: RatingRadio,
	ScaleSelect: ScaleSelect,
};
